import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TapableTerminalCard } from './component/tapable-terminal-card.component';
import { MaterialModule } from '@sdbn/appclient';

@NgModule({
  declarations: [
    TapableTerminalCard
  ],
  exports: [
    TapableTerminalCard
  ],
  imports: [
    CommonModule,
    MaterialModule
  ]
})
export class TapableTerminalCardModule { }
